import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { K1DashboardProvider } from "@/features/K1Dashboard/context/K1DashboardProvider";
import K1CapitalAccountView from "@/features/K1Dashboard/views/CapitalAccountView";

export default function K1CapitalAccount() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Capital Account");
  }, []);

  return (
    <K1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <K1CapitalAccountView />
      </main>
    </K1DashboardProvider>
  );
}
